//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/v2";
//#endregion

const DialogAlertConfirmUpdateSpace = ({
    dialog, confirm, content
}) => {
    return (
        <DialogAlertAction
            dialog={dialog}
            widthContent="100%"
            variant="secondary"
            title="¿Deseas guardar el cambio del espacio?"
            contentComponent={<p className="paragraph center">{content}</p>}>
            <CustomButton
                width="120px"
                variant="secondary"
                text="No, cancelar"
                onClick={dialog.hide}/>
            <CustomButton
                width="120px"
                text="Sí, guardar"
                onClick={confirm}/>
        </DialogAlertAction>
    );
}

export default DialogAlertConfirmUpdateSpace;